import { render, staticRenderFns } from "./cadastroItems.vue?vue&type=template&id=cb7209d2&scoped=true&"
import script from "./cadastroItems.vue?vue&type=script&lang=js&"
export * from "./cadastroItems.vue?vue&type=script&lang=js&"
import style0 from "./cadastroItems.vue?vue&type=style&index=0&id=cb7209d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7209d2",
  null
  
)

export default component.exports